<template>
	<div>
		<v-menu left attach="#app-menu" offset-y :close-on-content-click="false">
			<template v-slot:activator="{ on }">
				<v-btn class="NavbarUserMenu-btn" text v-on="on">
					<v-icon>mdi-account</v-icon>
				</v-btn>
			</template>
			<v-list flat>
				<v-list-item link :to="{ name: 'auth-profile' }">
					<v-list-item-icon>
						<v-icon>mdi-account-circle</v-icon>
					</v-list-item-icon>
					<v-list-item-title> Profile </v-list-item-title>
				</v-list-item>
				<v-divider />
				<v-list-item link @click="logout" class="mt-2">
					<v-list-item-icon>
						<v-icon>mdi-logout-variant</v-icon>
					</v-list-item-icon>
					<v-list-item-title> Sign Out </v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</div>
</template>

<script>
import { AuthService } from '../../services/storageService';

export default {
	methods: {
		logout() {
			AuthService.clearToken();
			this.$router.push('/auth/login');
		},
	},
};
</script>

<style>
.NavbarUserMenu-btn.v-btn {
	min-width: 0 !important;
}
</style>
